export const media = () => {
    let design
    if (window.matchMedia('only screen and (min-width: 1200px)').matches) {
        design = 'desktop'
    } else if (window.matchMedia('only screen and (min-width: 992px)').matches) {
        design = 'laptop'
    } else if (
        window.matchMedia('only screen and (min-width: 768px) and (orientation: landscape)').matches ||
        window.matchMedia('only screen and (min-width: 600px) and (orientation: portrait)').matches) {
        design = 'tablet'
    } else if (window.matchMedia('screen').matches) {
        design = 'mobile'
    }
    return design
}
